/**
 * Tenant State Module
 *
 * Module-level state for tenant/orgId that can be accessed outside React components.
 * Updated by TenantProvider when tenant changes.
 */

let currentOrgId: string | null = null;
let authOrgId: string | null = null;

/**
 * Set current orgId (called by TenantProvider)
 */
export function setCurrentOrgId(orgId: string | null) {
  currentOrgId = orgId;
}

/**
 * Set auth orgId (called by TenantProvider)
 */
export function setAuthOrgId(orgId: string | null) {
  authOrgId = orgId;
}

/**
 * Get effective orgId (current override or auth orgId)
 * Can be called from non-React code (e.g., api-client)
 */
export function getEffectiveOrgId(): string | null {
  return currentOrgId || authOrgId || null;
}
